var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"lg"}},[_c('DeliveryStateCards',{staticClass:"mb-2"}),_c('StoreMessages',{staticClass:"mb-2"}),_c('ListPickupRequests',{ref:"listPickupRequests"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }